import { render, staticRenderFns } from "./ComercializadoraList.vue?vue&type=template&id=7cdc8980&scoped=true"
import script from "./ComercializadoraList.vue?vue&type=script&lang=js"
export * from "./ComercializadoraList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdc8980",
  null
  
)

export default component.exports